import { makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
  card: {
    boxShadow: '0px 12px 20px 4px rgba(212, 209, 227, 0.5)',
    padding: 30,
    backgroundColor: '#fff',
    borderRadius: 12,
  },
}))

const CardBox = ({ children, className }) => {
  const classes = useStyles()
  return <div className={`${classes.card} ${className}`}>{children}</div>
}

export default CardBox
